module.exports = "https://la-static.prod-my.games/minigames/collection/img/not_available.bdcb3f5b.svg";